export const UK_PHONE_NUMBER_PREFIX = '+44'
export const MAX_AMOUNT_LENGTH = 15
